<template lang="pug">
v-tooltip(bottom content-class="tooltip--long")
  v-icon(slot='activator', dark, color='secondary')
    | info_outline
  span
    | {{ C.data.message }}
</template>
<script>
  export default {
    components: {},
    props: ['message'],
    data () {
      return {
        C: {
          data: {
            message: ''
          }
        }
      }
    },
    created () {
      var component = this

      component.C.data.message = component.message
    }
  }
</script>
<style scoped >

</style>



// WEBPACK FOOTER //
// src/components/Inventions/BasicTooltip.vue